import { useRef, TextareaHTMLAttributes, FC } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import S from "./index.module.scss";

interface ITextarea extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
  required?: boolean;
  register: UseFormRegisterReturn;
}

const Textarea: FC<ITextarea> = ({ label, error, required, register, ...props }) => {
  const localRef = useRef<HTMLTextAreaElement>(null);

  const resize = () => {
    const el = localRef.current;
    if (el) {
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }
  };

  return (
    <div className={S.container}>
      <div className={S.textareaWrapper}>
        <label className={S.label}>{label}</label>

        <textarea
          className={S.textarea}
          {...props}
          {...register}
          ref={el => {
            register.ref(el);
            localRef.current = el;
          }}
          onChange={e => {
            register.onChange(e);
            resize();
          }}
        />

        {required && <span className={S.required}>*</span>}
      </div>

      {error && <span className={S.error}>{error}</span>}
    </div>
  );
};

export default Textarea;
